import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdLock,
  MdImage,
  MdDashboard,
  MdAdd,
  MdSchool,
  MdPerson,
  MdPhotoLibrary,
  MdMenuBook,
  MdHotel,
  MdQuestionAnswer,
  MdVideoLibrary,
  MdRateReview,
  MdStar,
  MdEmojiEvents,
  MdPlace,
  MdViewHeadline,
  MdContactPhone
} from 'react-icons/md';

import MainDashboard from 'views/admin/default';
import FooterSettingsAdmin from 'views/admin/Footer/FooterSettings';
import SignInCentered from 'views/auth/signIn';
import HomepageBannerList from 'views/admin/HomePage/HomePageBanner/HomepageBannerList';
import Section1List from 'views/admin/HomePage/Section1/Section1List';
import TeacherHeadingAdmin from 'views/admin/HomePage/HomeTeachers/TeacherHeadingAdmin';
import TeacherName from 'views/admin/HomePage/HomeTeachers/TeacherName';
import TeacherTraining from 'views/admin/HomePage/HomeTeacherTraining/HomeTeacherTraining';
import TeacherTrainingHeading from 'views/admin/HomePage/HomeTeacherTrainingOverview/HomeTeacherTrainingOverviewHeading';
import TeacherTrainingCards from 'views/admin/HomePage/HomeTeacherTrainingOverview/HomeTeacherTrainingOverviewCards';
import HomeFacilityCards from 'views/admin/HomePage/HomeFacilities/FacilitiesCard';
import HomeYogaAlliance from 'views/admin/HomePage/HomeYogaAlliance/YogaAlliance';
import HomeWhyChooseHeading from 'views/admin/HomePage/HomeWhyChoose/Heading';
import HomeWhyChooseCards from 'views/admin/HomePage/HomeWhyChoose/Cards';
import HomeTestinomialHeading from 'views/admin/HomePage/HomeTestinomial/Heading';
import AdminTestimonialForm from 'views/admin/HomePage/HomeTestinomial/cards';
import HomeWhatWeOffer from 'views/admin/HomePage/HomeWhatWeOffer/HomeWhatWeOffer';
import HomeVideoSection from 'views/admin/HomePage/HomeVideoSection/HomeVideoSection';
import HomeVideoSectionTwo from 'views/admin/HomePage/HomeVideoSectionTwo/HomeVideoSectionTwo';
import HomeFaqHeading from 'views/admin/HomePage/HomeFAq/HomeFAQ';
import HomeGivingBack from 'views/admin/HomePage/GivingBackSection/GivingBackSection';
import HowToReachHeading from 'views/admin/HomePage/HowToReach/heading';
import HeaderAdmin from 'views/admin/Header/HeaderAdmin';
import AyurvedaSectionAdmin from 'views/admin/HomePage/HomeAyurvedaSection/AyurvedaSection';
import RetreatSectionAdmin from 'views/admin/HomePage/HomeRetreatSection/RetreatSection';
import AboutFounderSection from 'views/admin/AboutUs/Founder/Founder';
import AboutFounderDetails from 'views/admin/AboutUs/Founder/FounderDetails';
import AboutTeacherHeading from 'views/admin/AboutUs/Teachers/TeacherHeading';
import AboutCoursesDetails from 'views/admin/Courses/CoursesDetails';
import CourseBatches from 'views/admin/Courses/CourseBatches';
import CourseBookings from 'views/admin/Courses/CourseBookings';
import HomeStudentReview from 'views/admin/HomePage/StudentReview/StudentReview';
import AccommodationForm from 'views/admin/AboutUs/Accommodation/Accommodation';
import GalleryHeadingForm from 'views/admin/AboutUs/Gallery/Gallery';
import GalleryForm from 'views/admin/AboutUs/Gallery/GalleryHeading';
import BlogPosts from 'views/admin/Blog/BlogPosts';
import BlogPageContent from 'views/admin/Blog/BlogPageContent';
import OurSchoolAdmin from 'views/admin/OurSchool/OurSchoolAdmin';
import BooksAdmin from 'views/admin/AboutUs/Books/BooksAdmin';
import BooksPageContent from 'views/admin/AboutUs/Books/BooksPageContent';
import Hours24Form from 'views/admin/Courses/Hours24';
import RulesRefundForm from 'views/admin/Courses/RulesRefundForm';
import VedicMantraForm from 'views/admin/Courses/VedicMantraForm';
import AyurvedaForm from 'views/admin/Courses/Ayurveda';
import OnlineYogaForm from 'views/admin/Courses/OnlineYoga';
import AboutUsForm from 'views/admin/AboutUs/AboutUs';
import YinYogaAdmin from 'views/admin/Courses/YinYoga';
import OnlineYogaTTCForm from 'views/admin/Courses/YogaTTC';
import ContactUsAdmin from "views/admin/Settings/ContactUsAdmin";


const routes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/default',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
        name: 'Header Settings',
        layout: '/admin',
        path: '/homepage/header',
        icon: <Icon as={MdViewHeadline} width="20px" height="20px" color="inherit" />,
        component: <HeaderAdmin />,
      },
  {
    name: 'Footer Settings',
    layout: '/admin',
    path: '/footer-setting',
    icon: <Icon as={MdViewHeadline} width="20px" height="20px" color="inherit" />,
    component: <FooterSettingsAdmin />,
  },
  {
    name: "Contact Us",
    layout: "/admin",
    path: "/contact-us",
    icon: <Icon as={MdContactPhone} width="20px" height="20px" color="inherit" />,
    component: <ContactUsAdmin />,
  },
  {
      name: 'Course Bookings',
      layout: '/admin',
      path: '/Courses/Bookings',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <CourseBookings />,
    },
  {
    name: 'HomePage',
    layout: '/admin',
    path: '/homepage',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      
      {
        name: 'Ayurveda Section',
        layout: '/admin',
        path: '/homepage/ayurveda-section',
        icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
        component: <AyurvedaSectionAdmin />,
      },
      {
        name: 'Retreat Section',
        layout: '/admin',
        path: '/homepage/retreat-section',
        icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
        component: <RetreatSectionAdmin />,
      },
      {
        name: 'HomePage Banner',
        layout: '/admin',
        path: '/homepage/banner',
        icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
        component: <HomepageBannerList />,
      },
      {
        name: 'Section1',
        layout: '/admin',
        path: '/homepage/section1',
        icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />,
        component: <Section1List />,
      },
      {
        name: 'Home Teacher Courses',
        layout: '/admin',
        path: '/homepage/teacher-courses',
        icon: <Icon as={MdSchool} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Teacher MainHeading',
            layout: '/admin',
            path: '/homepage/teacher-courses/heading',
            icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
            component: <TeacherHeadingAdmin />,
          },
          {
            name: 'Teacher Name',
            layout: '/admin',
            path: '/homepage/teacher-courses/name',
            icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
            component: <TeacherName />,
          },
        ],
      },
      {
        name: 'Home Teacher Training',
        layout: '/admin',
        path: '/homepage/teacher-training',
        icon: <Icon as={MdSchool} width="20px" height="20px" color="inherit" />,
        component: <TeacherTraining />,
      },
      {
        name: 'Teacher Training Overview',
        layout: '/admin',
        path: '/homepage/training-overview',
        icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Training Overview Heading',
            layout: '/admin',
            path: '/homepage/training-overview/heading',
            icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />,
            component: <TeacherTrainingHeading />,
          },
          {
            name: 'Training Overview Cards',
            layout: '/admin',
            path: '/homepage/training-overview/cards',
            icon: <Icon as={MdStar} width="20px" height="20px" color="inherit" />,
            component: <TeacherTrainingCards />,
          },
        ],
      },
      {
        name: 'Home Facility',
        layout: '/admin',
        path: '/homepage/facility',
        icon: <Icon as={MdHotel} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Facility Cards',
            layout: '/admin',
            path: '/homepage/facility/cards',
            icon: <Icon as={MdHotel} width="20px" height="20px" color="inherit" />,
            component: <HomeFacilityCards />,
          },
        ],
      },
      {
        name: 'Home Yoga Alliance',
        layout: '/admin',
        path: '/homepage/yoga-alliance',
        icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
        component: <HomeYogaAlliance />,
      },
      {
        name: 'Home Why Choose',
        layout: '/admin',
        path: '/homepage/why-choose',
        icon: <Icon as={MdStar} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Why Choose Heading',
            layout: '/admin',
            path: '/homepage/why-choose/heading',
            icon: <Icon as={MdStar} width="20px" height="20px" color="inherit" />,
            component: <HomeWhyChooseHeading />,
          },
          {
            name: 'Why Choose Cards',
            layout: '/admin',
            path: '/homepage/why-choose/cards',
            icon: <Icon as={MdStar} width="20px" height="20px" color="inherit" />,
            component: <HomeWhyChooseCards />,
          },
        ],
      },
      {
        name: 'Home Testimonial',
        layout: '/admin',
        path: '/homepage/testimonial',
        icon: <Icon as={MdRateReview} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Testimonial Heading',
            layout: '/admin',
            path: '/homepage/testimonial/heading',
            icon: <Icon as={MdRateReview} width="20px" height="20px" color="inherit" />,
            component: <HomeTestinomialHeading />,
          },
          {
            name: 'Testimonial Cards',
            layout: '/admin',
            path: '/homepage/testimonial/cards',
            icon: <Icon as={MdRateReview} width="20px" height="20px" color="inherit" />,
            component: <AdminTestimonialForm />,
          },
        ],
      },
      {
        name: 'What We Offer',
        layout: '/admin',
        path: '/homepage/what-we-offer',
        icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />,
        component: <HomeWhatWeOffer />,
      },
      {
        name: 'Homepage Video Section',
        layout: '/admin',
        path: '/homepage/video-section',
        icon: <Icon as={MdVideoLibrary} width="20px" height="20px" color="inherit" />,
        component: <HomeVideoSection />,
      },
      {
        name: 'Homepage Video Section Two',
        layout: '/admin',
        path: '/homepage/video-section-two',
        icon: <Icon as={MdVideoLibrary} width="20px" height="20px" color="inherit" />,
        component: <HomeVideoSectionTwo />,
      },
      {
        name: 'Homepage FAQ',
        layout: '/admin',
        path: '/homepage/faq',
        icon: <Icon as={MdQuestionAnswer} width="20px" height="20px" color="inherit" />,
         component: <HomeFaqHeading />,
      },
      {
        name: 'Giving Back Section',
        layout: '/admin',
        path: '/homepage/giving-back',
        icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />,
        component: <HomeGivingBack />,
      },
      {
        name: 'How To Reach Us',
        layout: '/admin',
        path: '/homepage/how-to-reach',
        icon: <Icon as={MdPlace} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Heading',
            layout: '/admin',
            path: '/homepage/how-to-reach/heading',
            icon: <Icon as={MdPlace} width="20px" height="20px" color="inherit" />,
            component: <HowToReachHeading />,
          },
        ],
      },
      {
        name: 'Student Review',
        layout: '/admin',
        path: '/homepage/student-review',
        icon: <Icon as={MdRateReview} width="20px" height="20px" color="inherit" />,
        component: <HomeStudentReview />,
      },
    ],
  },
  {
    name: 'AboutUS',
    layout: '/admin',
    path: '/about-us',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
       {
            name: 'AboutUs',
            layout: '/admin',
            path: '/about-us/Page',
            icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
            component: <AboutUsForm/>,
          },
      {
        name: 'Founder',
        layout: '/admin',
        path: '/about-us/founder',
        icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'Founder Details',
            layout: '/admin',
            path: '/about-us/founder/details',
            icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
            component: <AboutFounderDetails />,
          },
          {
            name: 'Founder Section',
            layout: '/admin',
            path: '/about-us/founder/Section',
            icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
            component: <AboutFounderSection />,
          },
        ],
      },
      {
        name: 'Teacher',
        layout: '/admin',
        path: '/about-us/Teacher',
        icon: <Icon as={MdSchool} width="20px" height="20px" color="inherit" />,
        component: <AboutTeacherHeading />,
      },
       {
      name: 'Our School Page',
      layout: '/admin',
      path: '/about-us/our-school',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <OurSchoolAdmin />,
    },
    
      {
        name: 'Gallery',
        layout: '/admin',
        path: '/AboutUs/Gallery',
        icon: <Icon as={MdPhotoLibrary} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
          {
            name: 'GalleryHeading',
            layout: '/admin',
            path: '/AboutUs/Gallery/Heading',
            icon: <Icon as={MdPhotoLibrary} width="20px" height="20px" color="inherit" />,
            component: <GalleryForm />,
          },
          {
            name: 'Gallery',
            layout: '/admin',
            path: '/AboutUs/Gallery/images',
            icon: <Icon as={MdPhotoLibrary} width="20px" height="20px" color="inherit" />,
            component: <GalleryHeadingForm />,
          },
        ],
      },
      {
        name: 'Accommodation',
        layout: '/admin',
        path: '/AboutUs/Accommodation',
        icon: <Icon as={MdHotel} width="20px" height="20px" color="inherit" />,
        component: <AccommodationForm />,
      },
      
      {
        name: 'Books',
        layout: '/admin',
        path: '/AboutUs/Books',
        icon: <Icon as={MdPhotoLibrary} width="20px" height="20px" color="inherit" />,
        collapse: true,
        items: [
      {
        name: 'Books',
        layout: '/admin',
        path: '/AboutUs/Books/Heading',
        icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
        component: <BooksAdmin/>,
      },
      {
   name: 'Books Details',
   layout: '/admin',
   path: '/AboutUs/Books/Details',
   icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
   component: <BooksPageContent/>,
 }

    ]
  },
  
    ],
  },
   {
  name: 'Courses',
  layout: '/admin',
  path: '/Courses',
  icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
  collapse: true,
  items: [
    {
      name: 'Courses Catalog',
      layout: '/admin',
      path: '/Courses/Courses-Details',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <AboutCoursesDetails />,
    },
    {
      name: 'Course Batches',
      layout: '/admin',
      path: '/Courses/Batches',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <CourseBatches />,
    },
     {
      name: 'Hours24Form',
      layout: '/admin',
      path: '/Courses/Hours-24-Form',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <Hours24Form/>,
    },
     {
      name: 'RulesRefundForm',
      layout: '/admin',
      path: '/Courses/RulesRefundForm',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <RulesRefundForm/>,
    },
    {
      name: 'VedicMantraForm',
      layout: '/admin',
      path: '/Courses/VedicMantraForm',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <VedicMantraForm/>,
    },
     {
        name: 'Yin Yoga',
        layout: '/admin',
        path: '/Courses/Yin-Yoga',
        icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
        component: <YinYogaAdmin />,
      },
      {
      name: 'YogaTTC',
      layout: '/admin',
      path: '/Courses/YogaTTC',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <OnlineYogaTTCForm/>,
    },
     {
  name: 'OnlineYoga',
  layout: '/admin',
  path: '/OnlineYogaForm',
  icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
  component: <OnlineYogaForm/>,
},
  ],
},
{
  name: 'Blog',
  layout: '/admin',
  path: '/blog',
  icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
  collapse: true,
  items: [
    {
      name: 'Blog Posts',
      layout: '/admin',
      path: '/blog/posts',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <BlogPosts />,
    },
    {
      name: 'Blog Page Content',
      layout: '/admin',
      path: '/blog/Heading',
      icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
      component: <BlogPageContent />,
    },
  ],
},
{
  name: 'Ayurveda',
  layout: '/admin',
  path: '/Ayurveda',
  icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
  component: <AyurvedaForm/>,
},

//   {
//   name: 'AboutUS',
//   layout: '/admin',
//   path: '/about-us',
//   icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
//   collapse: true,
//   items: [
//     {
//       name: 'Founder',
//       layout: '/admin',
//       path: '/about-us/founder',
//       icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//       collapse: true,
//       items: [
//         {
//           name: 'Founder Details',
//           layout: '/admin',
//           path: '/about-us/founder/details',
//           icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//           component: <AboutFounderDetails/>,
//         },
//          {
//           name: 'Founder Section',
//           layout: '/admin',
//           path: '/about-us/founder/Section',
//           icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//           component: <AboutFounderSection/>,
//         },
//       ],
//     },
//      {
//       name: 'Teacher',
//       layout: '/admin',
//       path: '/about-us/Teacher',
//       icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//       collapse: true,
//       items: [
//         {
//           name: 'Teacher Details',
//           layout: '/admin',
//           path: '/about-us/Teacher/details',
//           icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//           component: <AboutTeacherDetails />,
//         },
//          {
//           name: 'Teacher Section',
//           layout: '/admin',
//           path: '/about-us/Teacher/Section',
//           icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//           component: <AboutTeacherHeading/>,
//         },
//       ],
//     },
//   ],
// },
// {
//   name: 'Courses',
//   layout: '/admin',
//   path: '/Courses',
//   icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
//   collapse: true,
//   items: [
//     {
//       name: 'Courses Catalog',
//       layout: '/admin',
//       path: '/Courses/Courses-Details',
//       icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//       component: <AboutCoursesDetails />,
//     },
//     {
//       name: 'Course Batches',
//       layout: '/admin',
//       path: '/Courses/Batches',
//       icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//       component: <CourseBatches />,
//     },
//     {
//       name: 'Course Bookings',
//       layout: '/admin',
//       path: '/Courses/Bookings',
//       icon: <Icon as={MdAdd} width="20px" height="20px" color="inherit" />,
//       component: <CourseBookings />,
//     },
//   ],
// },
// {
//   name: 'Books',
//   layout: '/admin',
//   path: '/books',
//   icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
//   component: <BooksAdmin />,
// },
// {
//   name: 'Books Page Content',
//   layout: '/admin',
//   path: '/books-page',
//   icon: <Icon as={MdImage} width="20px" height="20px" color="inherit" />,
//   component: <BooksPageContent />,
// },

  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
  },
];

export default routes;
